(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lmm-retirement-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmm-retirement-countdown')) {
    customElements.define('lmm-retirement-countdown', class extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.end = Date.parse(this.dataset.end);
        this.update();
        if (Number.isFinite(this.start) && Number.isFinite(this.end) && Date.now() < this.end) {
          this.timer = setInterval(() => this.update(), 1000);
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      update() {
        const now = Date.now();
        if (!Number.isFinite(this.start) || !Number.isFinite(this.end) || now < this.start) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        if (now >= this.end) {
          this.querySelector('.lmm-retirement__heading').textContent = this.dataset.retired;
          this.querySelector('.lmm-retirement__clock').hidden = true;
          clearInterval(this.timer);
          return;
        }
        const remaining = Math.ceil((this.end - now) / 1000);
        const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
        for (const [unit, value] of Object.entries(values)) {
          this.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
